import script from "./SuccessGifty.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessGifty.vue?vue&type=script&setup=true&lang=js"

import "./SuccessGifty.vue?vue&type=style&index=0&id=148fd5d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-148fd5d4"]])

export default __exports__